import { Component, Input } from '@angular/core';
import { PalleteColor } from 'nanaykuna-ui-kit/loader';

@Component({
  selector: 'unicon-field-label-wrapper',
  templateUrl: './field-label-wrapper.component.html',
})
export class FieldLabelWrapperComponent {
  @Input() label!: string;
  @Input() labelType: string = 'h12';
  @Input() labelColor: PalleteColor = 'neutrals-900';
  @Input() gap: string = '2';
}
